import type { SectionCategoryEntry } from '@heidi/integrations/ehr/contracts';

// Keep in sync with the Medatixx `pvsSystemName` entries in
// `src/helpers/ehrProviderMetadata.ts`, which is the canonical provider metadata
// source, and with the Rust list in
// `tauri-plugin/integrations/tauri-plugin-gdt/src/pvs/medatixx.rs`.
const MEDATIXX_PVS_SYSTEM_NAMES = [
  'medatixx',
  'Medatixx x.comfort',
  'Medatixx x.concept',
  'Medatixx x.vianova',
  'Medatixx xentro',
] as const;

const MEDATIXX_GDT_SECTION_MAPPINGS: SectionCategoryEntry[] = [
  { fieldId: '6330', sectionName: 'Anamnese', categoryCode: 'BE' },
  { fieldId: '6330', sectionName: 'Befund', categoryCode: 'BE' },
  { fieldId: '6330', sectionName: 'Therapie', categoryCode: 'BE' },
  { fieldId: '6330', sectionName: 'Procedere', categoryCode: 'BE' },
];

function normalisePvsName(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, '');
}

export function isMedatixxPvsSystemName(name?: string | null): boolean {
  if (!name) return false;
  const normalised = normalisePvsName(name);
  return MEDATIXX_PVS_SYSTEM_NAMES.some(
    (pvsName) => normalisePvsName(pvsName) === normalised
  );
}

export function getMedatixxDefaultGdtSectionMappings(): SectionCategoryEntry[] {
  return MEDATIXX_GDT_SECTION_MAPPINGS.map((entry) => ({ ...entry }));
}
